export const recoverNavLang = () => {
  const language = window.navigator.language;
  const country = language.split('-')[1];
  return country?.toUpperCase() ?? 'FR';
};
